export default "__VITE_ASSET__Cn2_Hagi__"